import React from 'react';
import SelectEngine from '../engine/SelectEngine';
import _OutlinedInput from '../OutlinedInput';
import styled from 'styled-components/macro';
import BellIcon from '@material-ui/icons/Notifications';
import RepeatIcon from '@material-ui/icons/Autorenew';
import Colors from '../../internal-components/Colors';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const OutlinedInput = styled(_OutlinedInput)`
  && {
    height: 1rem;
    margin-right: 1rem;
    min-width: 5rem;
    width: 5rem;
  }
`;

const IconWrapper = styled.div`
  align-self: center;
  height: 1rem;
`;

const BlueBell = styled(BellIcon)`
  && {
    color: ${Colors.PRIMARY};
    height: 1rem;
    line-height: 1rem;
  }
`;

const GreyRepeat = styled(RepeatIcon)`
  && {
    color: ${({ $active }) => ($active ? Colors.PRIMARY : Colors.OT_GREY)};
    height: 1rem;
    line-height: 1rem;
    transform: rotate(90deg);
  }
`;

const GridOuter = styled.div`
  display: grid;
  grid-template-columns: 50px 100px 400px;
  grid-template-rows: auto;
`;

const GridCell = styled.div`
  align-self: ${({ $top }) => ($top ? 'top' : 'center')};
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  padding-top: ${({ $top }) => ($top ? '12px' : null)};
`;

const AfterContainer = styled.div`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`;

const TitleDiv = styled.div`
  font-weight: 500;
`;

const TaskFrequencyOverdueView = props => {
  return (
    <div>
      <TitleDiv>When a task is overdue</TitleDiv>
      <div>Note: Email reminders are sent at X am.</div>
      <GridOuter>
        <GridCell>
          <IconWrapper>
            <BlueBell />
          </IconWrapper>
        </GridCell>
        <GridCell>
          <OutlinedInput
            numeric
            value={props.count}
            onChange={e => {
              props.setCount(e.target.value || 0);
            }}
          />
        </GridCell>
        <GridCell>
          <SelectEngine
            options={[
              { text: 'Days', value: 'days' },
              { text: 'Weeks', value: 'weeks' },
              { text: 'Months', value: 'months' }
            ]}
            value="days"
          ></SelectEngine>{' '}
          after due date
        </GridCell>
        <GridCell>
          <IconWrapper>
            <GreyRepeat $active={props.repeat} />
          </IconWrapper>
        </GridCell>
        <GridCell>Repeat:</GridCell>
        <GridCell>
          <SelectEngine
            options={[
              { text: 'Select', value: '' },
              { text: 'Daily', value: 'daily' },
              { text: 'Weekly', value: 'weekly' },
              { text: 'Monthly', value: 'monthly' }
            ]}
            onChange={props.setRepeat}
            placeholder="Select"
            value={props.repeat}
          ></SelectEngine>
        </GridCell>
        <GridCell $hidden={!props.repeat}>
          <IconWrapper></IconWrapper>
        </GridCell>
        <GridCell $hidden={!props.repeat} $top>
          End repeat:
        </GridCell>
        <GridCell $hidden={!props.repeat}>
          <RadioGroup
            value={props.repeatEnd}
            onChange={e => {
              props.setRepeatEnd(e.target.value);
            }}
          >
            <div>
              <FormControlLabel
                control={<Radio color="primary" />}
                value="complete"
                label="When the task is complete"
              />
            </div>
            <div>
              <FormControlLabel
                control={<Radio color="primary" />}
                value="custom"
                label="Custom"
              />
            </div>
          </RadioGroup>
          <AfterContainer $hidden={props.repeatEnd !== 'custom'}>
            After{' '}
            <OutlinedInput
              numeric
              value={props.repeatEndDays}
              onChange={e => {
                props.setRepeatEndDays(e.target.value || 0);
              }}
            />{' '}
            days
          </AfterContainer>
        </GridCell>
      </GridOuter>
    </div>
  );
};

export default TaskFrequencyOverdueView;
